export const CLINIC_INFO_KEYS = {
  organization_name: 'clinicName',
  email: 'email',
  slug: 'userName',
  website: 'website',
};
